import { useTheme } from "@mui/material/styles";
import { createContext, useEffect, useState } from "react";

export const ResponsiveContext = createContext();

export const ResponsiveProvider = ({ children }) => {
  const theme = useTheme();

  const [deviceState, setDeviceState] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  useEffect(() => {
    const isMobile = window.innerWidth <= theme.breakpoints.values.sm;
    const isTablet =
      window.innerWidth > theme.breakpoints.values.sm &&
      window.innerWidth <= 830;
    const isDesktop = window.innerWidth > theme.breakpoints.values.md;
    setDeviceState({ isMobile, isTablet, isDesktop });
  }, [window.innerWidth]);

  const onResizeHandler = () => {
    const isMobile = window.innerWidth <= theme.breakpoints.values.sm;
    const isTablet =
      window.innerWidth > theme.breakpoints.values.sm &&
      window.innerWidth <= theme.breakpoints.values.md;
    const isDesktop = window.innerWidth > theme.breakpoints.values.md;

    setDeviceState({ isMobile, isTablet, isDesktop });
  };

  const debouncedResizeHandler = onResizeHandler;

  useEffect(() => {
    const setup = () => {
      window.addEventListener("resize", debouncedResizeHandler, false);
    };
    const cleanup = () => {
      window.removeEventListener("resize", debouncedResizeHandler, false);
    };

    setup();

    return () => {
      cleanup();
    };
  }, [debouncedResizeHandler]);

  return (
    <ResponsiveContext.Provider value={deviceState}>
      {children}
    </ResponsiveContext.Provider>
  );
};
